export default {
  STORAGE: {
    IDENTITY_INFO: 'IDENTITY_INFO',
    // DYNA LiveWeb 跳转会离开当前 SPA，这里用 sessionStorage 暂存回跳所需上下文和结果。
    DYNA_LIVE_WEB_CONTEXT: 'DYNA_LIVE_WEB_CONTEXT',
    DYNA_LIVE_WEB_CALLBACK: 'DYNA_LIVE_WEB_CALLBACK',
    PAY_FACE_AUTH_CONTEXT: 'PAY_FACE_AUTH_CONTEXT',
    RESTAURANT_NO: 'RESTAURANT_NO',
    TABLE_UUID: 'TABLE_UUID',
    RESTAURANT_INFO: 'RESTAURANT_INFO',
    TOKEN: 'TOKEN',
    TOKEN_JT: 'TOKEN_JT',
    TABLE_INFO: 'TABLE_INFO',
    FCM_TOKEN: 'FCM_TOKEN',

    A_CC: 'A_CC',
    P_CC: 'P_CC',

    QR_SELECT_LIST: 'QR_SELECT_LIST',
    CHANNEL_LIST: 'CHANNEL_LIST',
    PAYMENT_LIST: 'PAYMENT_LIST',
    PAYMENT_SUMMARY: 'PAYMENT_SUMMARY'
  },
  MODE: {
    PAYMENT_FONT: 1,
    PAYMENT_AFTER: 2
  },

  PAYMENT_WAY: {
    ONLINE: 1,
    CASH: 2
  },
  ORDER_TYPE: {
    MAIN: 1,
    ASSISTANT: 2
  },
  SERVICE_FEE_TYPE: {
    FIXED: 1,
    SCALE: 2
  },
  SERVICE_FEE_STATUS: {
    OPEN: 1,
    CLOSE: 2
  },
  HTTP_METHOD: {
    GET: 'get',
    POST: 'post'
  },
  SOLD_OUT: {
    YES: 2,
    NO: 1
  },
  PAYMENT_STATUS: [
    // { text: 'Pending', key: 1 },
    { text: 'Success ', key: 2 },
    { text: 'Failed ', key: 3 },
    { text: 'Close', key: 4 }
  ],
  PAYMENT_PENDING: 1,
  PAYMENT_SUCCESS: 2,
  PAYMENT_FAILED: 3,
  PAYMENT_CLOSE: 4,

  // 后端 `channel` 返回值统一从这里取，避免 bluepay KYC 流程里散落硬编码。
  EKYC_CHANNEL: {
    ZOLOZ: 'ZOLOZ',
    DYNA: 'DYNA',
    ONFIDO: 'ONFIDO'
  },

  // DYNA LiveWeb 只保留非敏感基础配置。
  // account_id / app_key 密文走独立解密工具，避免在常量层直接暴露读取入口。
  DYNA_LIVE_WEB: {
    HOST: process.env.VUE_APP_DYNA_LIVE_WEB_HOST || 'kyc.dyna.tech',
    SUPPORTED_LANGS: ['zh', 'en', 'fil', 'id', 'th', 'vi', 'es', 'bn']
  },

  // /ekycDynaApiLog/saveApiLog 的 api_type 枚举。
  EKYC_DYNA_API_LOG_API_TYPE: {
    OCR: 2,
    LIVE_WEB: 3
  },

  FACE_CAPTURE_BASE_URL: 'https://hk-production-cdn.zoloz.net/page/face-fe/index.html',
  FACE_RESOURCE_PACK_EN: 'https://m.bluepay.asia/zoloz/configForWeb_connect_en.json',
  FACE_RESOURCE_PACK_ZH: 'https://m.bluepay.asia/zoloz/configForWeb_connect_zh-CN.json',
  FACE_RESOURCE_PACK_TH: 'https://m.bluepay.asia/zoloz/configForWeb_connect_th.json',
  ZOLOZ_BASE_URL: 'https://hk-production-cdn.zoloz.net/page/realid-fe/index.html',
  ZOLOZ_RESOURCE_PACK: 'https://m.bluepay.asia/zoloz/configForWeb_realId_en-3.json',
  ZOLOZ_RESOURCE_PACK_ZH: 'https://m.bluepay.asia/zoloz/configForWeb_realId_zh-3.json',
  ZOLOZ_RESOURCE_PACK_TH: 'https://m.bluepay.asia/zoloz/configForWeb_realId_th-3.json',

  ZOLOZ_SDK_TIMEOUT: 60000,

  ZOLOZ_SDK_INTERRUPT_CODE: 1003, //中断
  ZOLOZ_SDK_COMPLETE_CODE: 1000, //成功
  ZOLOZ_SDK_FAIL_CODE: 2006, //失败

  ZOLOZ_EKYC_RESULT_SUCCESS: 1,
  ZOLOZ_EKYC_RESULT_PENDING: 3, //是ZOLOZ通道那边无法确认，需要人工审核
  ZOLOZ_EKYC_RESULT_IN_PROCESS: 4,

  FACE_ERROR_CODE: 21803,

  ID_TYPE: {
    ID_CARD: 1,
    PASSPORT: 2
  },

  NATIONALITY_CODE: 'TH',
  // Regular KYC status handling
  KYC_STATUS: {
    PENDING: 1,
    SUCCESS: 2,
    REFUSE: 3
  },

  // 银行卡审核状态
  BANK_STATUS: {
    PENDING: 1,
    SUCCESS: 2,
    REFUSE: 3
  },
  // Enhanced KYC status handling
  ENHANCED_KYC_STATUS: {
    UN_AUTH: 0,
    PROCESSING: 1,
    COMPLETED: 2,
    FAILED: 3
  },

  // kyc_level
  KYC_LEVEL: {
    UNAUTHORIZED: 1,
    E_KYC: 2, // 已通过基础kyc
    ENHANCED_KYC: 3 // 已通过高级kyc
  },

  USER_TYPE: {
    NONE: 0,
    PERSONAL: 1,
    ENTERPRISE: 2
  },

  // ekyc_status ，// 0未开始，1有基础，2有ekyc
  OLD_USER_KYC: {
    NONE: 0,
    BASE: 1,
    EKYC: 2,
    HIGEKYC: 3
  },

  PIN_STATUS: {
    UNSET: 0,
    NORMAL: 1,
    LOCKED: 2
  }
}
